import React from "react";
import AccountSummaryContent from "../common/AccountSummaryContent/AccountSummaryContent";

const PortfolioAccountSummary = () => {
	return <AccountSummaryContent />;
};

export default PortfolioAccountSummary;
